import { MatMenuModule as MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { MatTabsModule as MatTabsModule } from '@angular/material/tabs';
import { NgModule } from '@angular/core';

// modules (angular)
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// modules
import { SharedModule } from '@shared/shared.module';

// components
import { MobileHeaderComponent } from './components/mobile-header/mobile-header.component';
import { MobileLinksComponent } from './components/mobile-links/mobile-links.component';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { MenuItemsComponent } from './components/menu-items/menu-items.component';
import { AccountMenuComponent } from './components/account-menu/account-menu.component';
import { LanguagesComponent } from './components/languages/languages.component';
import { HeaderModule } from '../header/header.module';



@NgModule({
    imports: [
    // modules (angular)
    CommonModule,
    RouterModule,
    // modules
    SharedModule,
    HeaderModule,
    MatTabsModule,
    
    NgxMatSelectSearchModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    // components
    MobileHeaderComponent,
    MobileLinksComponent,
    MobileMenuComponent,
    MenuItemsComponent,
    LanguagesComponent,
    AccountMenuComponent
],
    exports: [
        // components
        MobileHeaderComponent,
        MobileMenuComponent
    ]
})
export class MobileModule { }
